/**
 * @generated SignedSource<<477d28a7db526c55c243cc311b186250>>
 * @relayHash 1b9f2207263d4440658e75bb0d078809
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7da9da94ae8102a1364f74843df2aa2d41475ba069516e2273826237442ca2c4

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAnalyticsAccountType = "AGENT" | "USER" | "%future added value";
export type ConfluencePageAnalyticsActorType = "AGENTS" | "ALL" | "PEOPLE" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type usePageViewsAnalyticsViewersWithActorTypeQuery$variables = {
  actorType?: ConfluencePageAnalyticsActorType | null;
  contentId: string;
  engageTimeThreshold?: number | null;
  isAgentPrivacyMaskingEnabled?: boolean | null;
  isPrivacyModeEnabled?: boolean | null;
  limit?: number | null;
};
export type usePageViewsAnalyticsViewersWithActorTypeQuery$data = {
  readonly contentAnalyticsViewsByUser: {
    readonly pageViews: ReadonlyArray<{
      readonly accountType: ConfluenceAnalyticsAccountType | null;
      readonly agentType: string | null;
      readonly confluenceUser: {
        readonly permissionType: SitePermissionType | null;
      } | null;
      readonly isEngaged: boolean | null;
      readonly isPrivate?: boolean | null;
      readonly lastVersionViewedNumber: number | null;
      readonly lastVersionViewedUrl: string | null;
      readonly lastViewedAt: string;
      readonly relatedUser: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly relatedUserAccountId: string | null;
      readonly userId?: string;
      readonly userProfile: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly views: number;
    }>;
  } | null;
  readonly singleContent: {
    readonly id: string | null;
    readonly subType: string | null;
    readonly version: {
      readonly number: number | null;
    } | null;
  } | null;
};
export type usePageViewsAnalyticsViewersWithActorTypeQuery = {
  response: usePageViewsAnalyticsViewersWithActorTypeQuery$data;
  variables: usePageViewsAnalyticsViewersWithActorTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actorType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "engageTimeThreshold"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAgentPrivacyMaskingEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivacyModeEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "contentId"
    }
  ],
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "singleContent",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "number"
        }
      ]
    }
  ]
},
v8 = [
  {
    "kind": "Variable",
    "name": "actorType",
    "variableName": "actorType"
  },
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "engageTimeThreshold",
    "variableName": "engageTimeThreshold"
  },
  {
    "kind": "Variable",
    "name": "isPrivacyModeEnabled",
    "variableName": "isPrivacyModeEnabled"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v10 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    },
    {
      "kind": "ScalarField",
      "name": "isPrimary"
    }
  ]
},
v11 = {
  "concreteType": "ContentAnalyticsPageViewInfo",
  "kind": "LinkedField",
  "name": "pageViews",
  "plural": true,
  "selections": [
    {
      "condition": "isAgentPrivacyMaskingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "userId"
        },
        {
          "kind": "ScalarField",
          "name": "isPrivate"
        }
      ]
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isActive"
        }
      ]
    },
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluenceUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "accountType"
    },
    {
      "kind": "ScalarField",
      "name": "agentType"
    },
    {
      "kind": "ScalarField",
      "name": "relatedUserAccountId"
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "relatedUser",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "views"
    },
    {
      "kind": "ScalarField",
      "name": "lastViewedAt"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedNumber"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedUrl"
    },
    {
      "kind": "ScalarField",
      "name": "isEngaged"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
    "selections": [
      (v7/*: any*/),
      {
        "args": (v8/*: any*/),
        "concreteType": "ContentAnalyticsViewsByUser",
        "kind": "LinkedField",
        "name": "contentAnalyticsViewsByUser",
        "plural": false,
        "selections": [
          (v11/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
    "selections": [
      (v7/*: any*/),
      {
        "args": (v8/*: any*/),
        "concreteType": "ContentAnalyticsViewsByUser",
        "kind": "LinkedField",
        "name": "contentAnalyticsViewsByUser",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1b9f2207263d4440658e75bb0d078809",
    "id": "7da9da94ae8102a1364f74843df2aa2d41475ba069516e2273826237442ca2c4",
    "metadata": {},
    "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
    "operationKind": "query",
    "text": "query usePageViewsAnalyticsViewersWithActorTypeQuery($contentId:ID!,$limit:Int,$engageTimeThreshold:Int,$isPrivacyModeEnabled:Boolean,$isAgentPrivacyMaskingEnabled:Boolean=false,$actorType:ConfluencePageAnalyticsActorType){singleContent(id:$contentId){id,subType,version{number}},contentAnalyticsViewsByUser(contentId:$contentId,limit:$limit,engageTimeThreshold:$engageTimeThreshold,isPrivacyModeEnabled:$isPrivacyModeEnabled,actorType:$actorType){pageViews{userId@include(if:$isAgentPrivacyMaskingEnabled)\n      isPrivate@include(if:$isAgentPrivacyMaskingEnabled),userProfile{id,displayName,photos{value,isPrimary},isActive},confluenceUser{permissionType},accountType,agentType,relatedUserAccountId,relatedUser{id,displayName,photos{value,isPrimary}},views,lastViewedAt,lastVersionViewedNumber,lastVersionViewedUrl,isEngaged},id}}"
  }
};
})();

(node as any).hash = "1a255bfb33f167068003601634f742a3";

export default node;
